import { type ReactNode } from 'react';
import { useDroppable } from '@dnd-kit/core';
import { cn } from '@/utils/cn';
import type { PaymentStatus } from '../types';
import { formatUSD } from '../utils/payment-formatters';

type Props = {
  status: PaymentStatus;
  label: string;
  count: number;
  totalAmount: number;
  children: ReactNode;
};

const COL =
  'flex w-[80vw] min-w-[240px] flex-col snap-center sm:w-[280px] sm:min-w-[280px] sm:snap-align-none';
const DROP =
  'flex-1 space-y-sm overflow-y-auto rounded-lg px-xs py-xs transition-colors scrollbar-thin';

export function PaymentColumn({
  status,
  label,
  count,
  totalAmount,
  children,
}: Props): ReactNode {
  const { setNodeRef, isOver } = useDroppable({ id: status });
  return (
    <div className={COL}>
      <div className="flex items-center gap-xs px-xs pb-sm">
        <span className="text-xs font-medium text-text-secondary">
          {label}{' '}
          <span className="text-text-tertiary">({formatUSD(totalAmount)})</span>
        </span>
        <span className="rounded-sm bg-white/[0.06] px-1.5 py-0.5 text-[10px] tabular-nums text-text-tertiary">
          {count}
        </span>
      </div>
      <div ref={setNodeRef} className={cn(DROP, isOver && 'bg-white/[0.03]')}>
        {children}
      </div>
    </div>
  );
}
